import { getSocket, disconnectSocket } from "../utils/socketConnection";
import {
    setPortfolioValue,
    setOpenPositionsDay,
    setOpenPositionsMonth,
    setClosedPositionsDay,
    setClosedPositionsMonth,
    setUnrealizedProfits,
    setRealizedProfits,
    setGlobalAlert,
} from "./actions";

export const socketMiddleware = (storeAPI) => {
    let socket;

    return (next) => (action) => {
        switch (action.type) {
            case "socket/start":
                socket = getSocket();

                // Clear prior listeners securely, preventing duplicates
                socket.removeAllListeners();

                socket.on("connect", () => {
                    console.log("Connected to WebSocket server");
                });

                socket.on("connect_error", (error) => {
                    console.error("WebSocket connection error:", error);
                    storeAPI.dispatch(
                        setGlobalAlert({
                            message: "Failed to connect to data server.",
                            severity: "error",
                        })
                    );
                });

                socket.on("disconnect", (reason) => {
                    if (reason === "io server disconnect") {
                        console.log("Disconnected from server by server");
                    } else {
                        console.log("Disconnected from server by client");
                    }
                    // Only dispatch alert if it's an unexpected server disconnect or transport error
                    if (reason !== "io client disconnect" && reason !== "client namespace disconnect") {
                        storeAPI.dispatch(
                            setGlobalAlert({
                                message: "Lost connection to data server. Attempting to reconnect...",
                                severity: "warning",
                            })
                        );
                    }
                });

                // Validation helper
                const isValidNumber = (data) => typeof data === "number" && !isNaN(data);

                socket.on("getPortfolioValue", (data) => {
                    if (isValidNumber(data)) {
                        storeAPI.dispatch(setPortfolioValue(data));
                    }
                });

                socket.on("getTodaysOpenPositions", (data) => {
                    if (isValidNumber(data)) {
                        storeAPI.dispatch(setOpenPositionsDay(data));
                    }
                });

                socket.on("getThisMonthOpenPositions", (data) => {
                    if (isValidNumber(data)) {
                        storeAPI.dispatch(setOpenPositionsMonth(data));
                    }
                });

                socket.on("getTodaysClosedPositions", (data) => {
                    if (isValidNumber(data)) {
                        storeAPI.dispatch(setClosedPositionsDay(data));
                    }
                });

                socket.on("getThisMonthClosedPositions", (data) => {
                    if (isValidNumber(data)) {
                        storeAPI.dispatch(setClosedPositionsMonth(data));
                    }
                });

                socket.on("getUnrealisedProfits", (data) => {
                    if (isValidNumber(data)) {
                        storeAPI.dispatch(setUnrealizedProfits(data));
                    }
                });

                socket.on("getRealisedProfits", (data) => {
                    if (isValidNumber(data)) {
                        storeAPI.dispatch(setRealizedProfits(data));
                    }
                });
                break;

            case "socket/stop":
                disconnectSocket();
                socket = null;
                break;

            default:
                break;
        }

        return next(action);
    };
};
